/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, bohdan, bohdev
 */
import React, { Component } from "react"
import { connect } from "react-redux"
import * as act from "../Session/actions"
import {
    LoginForm,
    tryLogin,
    Column,
    Row,
    Icon,
    Label,
    Button,
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    StepController,
    Step,
} from "trux"
import * as links from "../../util/links"
import sha1 from "js-sha1"

import traceBotImage from "../../assets/img/login-tracebot.svg"
import traceIDStar from "../../assets/img/traceid-star.svg"
import traceIDAbout from "../../assets/AboutTraceID.gif"
import emailSentImg from "../../assets/img/login-link-sent.png"
import slammersImage from "../../assets/img/slammers-fc.svg"

import "./ForceLogin.css"

class ForceLoginDialog extends Component {
    constructor(props) {
        super(props)

        this.state = {
            shown: true,
            step: "send-email",
            email: "",
            userId: "",
            token: "",
            error: null,
        }

        this.onEmailChanged = this.onEmailChanged.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.tryAgain = this.tryAgain.bind(this)
        this.onClose = this.onClose.bind(this)
        this.loginSuccess = this.loginSuccess.bind(this)
        this.loginFailure = this.loginFailure.bind(this)
    }

    isUserPage() {
        // let reg = /\/user\/?/gi
        // let up = reg.test(this.props.location.pathname)
        // console.log("isUserPage", this.props.location.pathname, up)
        return true
    }

    componentDidMount() {
        let event = new CustomEvent("trc-pause")
        document.dispatchEvent(event)
        this.handleUpdate()
    }

    componentDidUpdate() {
        this.handleUpdate()
    }

    loginSuccess() {
        let that = this
        let params = this.props.match.params
        let url = links.gameUrl(
            params.team_name,
            params.playlist_id,
            params.game_id,
            params.event_number
        )

        this.props.reset()

        setTimeout(() => {
            if (this.props.skipRedirectOnCompletion) return
            if (!that.isUserPage()) {
                let to = that.props.location.pathname.replace(
                    /\/userid.*$/gi,
                    ""
                )
                that.props.history.push(to)
            } else {
                that.props.history.push(url)
            }
        })
    }

    loginFailure() {
        // not much to do
    }

    handleUpdate() {
        console.log(
            "handleUpdate",
            this.props.isUserLoaded,
            this.props.isUserLoggedIn
        )
        if (this.props.isUserLoaded && this.props.isUserLoggedIn) {
            if (this.props.isUserLoggedIn && this.state.shown === true) {
                this.setState({ shown: false })
            } else if (
                !this.props.isUserLoggedIn &&
                this.state.shown === false
            ) {
                this.setState({ shown: true })
            }
        } else {
            this.tryLoginUser()
        }
    }

    tryLoginUser() {
        let that = this
        let params = this.props.match.params
        let url = links.gameUrl(
            params.team_name,
            params.playlist_id,
            params.game_id,
            params.event_number
        )

        tryLogin(this.props.location.pathname, (res, err) => {
            console.log("tryLogin callback", res, err)
            if (res) {
                that.props.reset()
                setTimeout(() => {
                    if (!that.isUserPage()) {
                        let to = that.props.location.pathname.replace(
                            /\/userid.*$/gi,
                            ""
                        )
                        that.props.history.push(to)
                    } else {
                        that.props.history.push(url)
                    }
                })
            }
        })
    }

    goToNext(url) {
        this.setState({ shown: false })
        this.props.history.replace(url)
    }

    onEmailChanged(value) {
        this.setState({ email: value })
    }

    onClose(e) {
        if (this.props.onClose) {
            this.props.onClose(this.props.history)
        } else {
            let path = this.props.location.pathname.replace(/save\/prof.*$/, "")
            this.props.history.push(path)
        }
    }

    onSubmit(e) {
        if (e) {
            e.preventDefault()
        }

        let error = null
        if (this.state.email.length < 3) {
            error = "email is required"
        }
        if (this.state.email.split("@").length < 2) {
            error = "email is required"
        }
        if (error) {
            this.setState({ error })
            return
        }
        if (this.state.error !== null) {
            this.setState({ error })
        }

        let link
        if (this.isUserPage()) {
            // eslint-disable-next-line no-template-curly-in-string
            link =
                window.location.href + "/magic/userid/${userId}/token/${token}"
        } else {
            // eslint-disable-next-line no-template-curly-in-string
            link = window.location.href + "/userid/${userId}/token/${token}"
        }
        let that = this
        this.props.sendMagicLink(this.state.email, link, (success) => {
            let next = { step: "check-email" }
            if (!success) {
                next = {
                    error: "We dont't have this email on file. Did you sign up with a different email?",
                }
            }
            that.setState(next)
        })
    }

    tryAgain(e) {
        this.setState({ step: "send-email" })
    }

    get addClassName() {
        return this.state.step
    }

    get dismissUrl() {
        return window.location.hash
            .replace(/^#/gi, "")
            .replace(/\/save\/profile(\/user)?$/gi, "")
    }

    render() {
        let up = this.isUserPage()
        console.log("isUserPage up", up)

        let cn = "ForceLogin"
        if (up) {
            cn += " UserLoginPage"
        }

        return (
            <Modal
                trkContext="Force Login"
                className={cn}
                open={this.state.shown}
                onShadeClick={this.onClose}
            >
                <StepController step={this.state.step}>
                    <Step name="sign-in">
                        <TitleSection onCloseClick={this.onClose} >
                            <ModalTitle content="Sign in to Trace" />
                        </TitleSection>
                        <ContentSection>
                            <Row center spacingBottom="4" span="12">
                                <LoginForm
                                    center
                                    onSuccess={this.loginSuccess}
                                    onFailure={this.loginFailure}
                                />
                            </Row>
                        </ContentSection>
                    </Step>

                    <Step name="send-email">
                        {!this.isUserPage() && (
                            <TitleSection onCloseClick={this.onClose}>
                                <ModalTitle
                                    content={
                                        <>
                                            Sign into Trace iD
                                            <i className="trace-id-star" />
                                        </>
                                    }
                                />
                            </TitleSection>
                        )}
                        {this.isUserPage() && (
                            <TitleSection onCloseClick={this.onClose} >
                                <ModalTitle content="Sign in to Trace" />
                            </TitleSection>
                        )}
                        <ContentSection>
                            <div className="dialog-save-to-profile-content send-email">
                                {!this.isUserPage() && (
                                    <>
                                        <Row center>
                                            <img
                                                src={traceIDAbout}
                                                alt="about trace id"
                                            />
                                        </Row>
                                        <div className="send-email-form">
                                            <Row>
                                                <Icon
                                                    color="var(--trace-regular-color)"
                                                    marginRight="2"
                                                    type={Icon.Type.Check}
                                                />
                                                <Label
                                                    span="10"
                                                    marginBottom="4"
                                                    content={
                                                        <>
                                                            <strong>
                                                                Organize:
                                                            </strong>{" "}
                                                            Add moments from any
                                                            match. Showcase
                                                            moments with tags to
                                                            add context.
                                                        </>
                                                    }
                                                />
                                            </Row>
                                            <Row>
                                                <Icon
                                                    color="var(--trace-regular-color)"
                                                    marginRight="2"
                                                    type={Icon.Type.Check}
                                                />
                                                <Label
                                                    span="10"
                                                    marginBottom="4"
                                                    content={
                                                        <>
                                                            <strong>
                                                                Share:
                                                            </strong>{" "}
                                                            The easiest way to
                                                            give anyone access
                                                            to the moments you
                                                            care about.
                                                        </>
                                                    }
                                                />
                                            </Row>
                                            <Row>
                                                <Icon
                                                    color="var(--trace-regular-color)"
                                                    marginRight="2"
                                                    type={Icon.Type.Check}
                                                />
                                                <Label
                                                    span="10"
                                                    marginBottom="4"
                                                    content={
                                                        <>
                                                            <strong>
                                                                Discover:
                                                            </strong>{" "}
                                                            Dive deep into a
                                                            moment with radar,
                                                            jumping to full
                                                            games, stats and
                                                            more.
                                                        </>
                                                    }
                                                />
                                            </Row>

                                            <Row center>
                                                <img
                                                    src={slammersImage}
                                                    height="19"
                                                    alt="Slammers FC"
                                                />
                                            </Row>
                                            <blockquote>
                                                &quot; It&apos;s really good, I
                                                know this because I had to
                                                purchase Adobe pro premier and
                                                learn that operating system. And
                                                it was very difficult. &quot;
                                            </blockquote>
                                            <Label
                                                className="quote-source"
                                                center
                                                bold
                                                content="Candace Van Den Bosch"
                                            />
                                            <Label
                                                className="quote-team"
                                                center
                                                small
                                                content="Slammers FC 02/01 ECNL Parent"
                                            />
                                        </div>
                                    </>
                                )}
                                {this.isUserPage() && (
                                    <Row
                                        center
                                        spacingBottom="4"
                                        span="12"
                                        className="user-login send-email-form"
                                    >
                                        <LoginForm
                                            center
                                            onSuccess={this.loginSuccess}
                                            onFailure={this.loginFailure}
                                        />
                                    </Row>
                                )}
                            </div>
                        </ContentSection>
                        {!this.isUserPage() && (
                            <FooterSection>
                                <Row center span="12">
                                    <Button
                                        primary
                                        trkAction="Go To Sign In"
                                        onClick={() => {
                                            this.setState({ step: "sign-in" })
                                        }}
                                        content="Sign into your Trace iD"
                                    />
                                </Row>
                            </FooterSection>
                        )}
                    </Step>
                    <Step name="check-email">
                        <TitleSection onCloseClick={this.onClose}>
                            <ModalTitle content="Log In" />
                        </TitleSection>
                        <ContentSection>
                            <div className="dialog-save-to-profile-content check-email">
                                {!this.isUserPage() && (
                                    <>
                                        <Row center className="trace-bot">
                                            <img
                                                height="120px"
                                                src={emailSentImg}
                                                alt="TraceBot sending email"
                                            />
                                        </Row>
                                        <Label
                                            type={Label.Type.Heading3}
                                            content="Check your inbox!"
                                            spacingTop="2"
                                            center
                                        />
                                        <Label
                                            content="Didn't get the login email?"
                                            center
                                        />
                                    </>
                                )}
                                {this.isUserPage() && (
                                    <>
                                        <Row center>
                                            <img
                                                height="120px"
                                                src={emailSentImg}
                                                alt="TraceBot sending email"
                                            />
                                        </Row>
                                        <Label
                                            type={Label.Type.Heading3}
                                            content="Check your inbox!"
                                            spacingTop="2"
                                            center
                                        />
                                        <Label
                                            content="Didn't get the login email?"
                                            center
                                            spacingBottom="8"
                                        />
                                    </>
                                )}
                            </div>
                        </ContentSection>
                        <FooterSection>
                            <Column center span="10">
                                <Button
                                    primary
                                    trkAction="Try Again Pressed"
                                    onClick={this.tryAgain}
                                    content="Try again"
                                />
                            </Column>
                        </FooterSection>
                    </Step>
                    <Step name="login">
                        <ContentSection>
                            <div className="dialog-save-to-profile-content login">
                                <Column center>
                                    <Label
                                        type={Label.Type.Heading4}
                                        marginBottom={8}
                                        content="Aaaand you are logged in, start adding moments!"
                                    />
                                    <div className="traceid-star">
                                        <img src={traceIDStar} alt="" />
                                    </div>
                                    <div className="spin"></div>
                                    <div className="trace-bot">
                                        <img src={traceBotImage} alt="" />
                                    </div>
                                </Column>
                            </div>
                        </ContentSection>
                    </Step>
                </StepController>
            </Modal>
        )
    }
}

const mapStateToPropsRU = (state, pageProps) => {
    let user = state.user.value
    let userOnWhiteList = false
    let preventPass = null
    if (pageProps.whitelist) {
        if (!user) {
            preventPass = state.user.complete
        } else {
            let email = user.email.toLowerCase().trim()
            let pass = checkWhitelisted(email, pageProps.whitelist)
            preventPass = !pass
            userOnWhiteList = pass
        }
    }

    let show = !state.user.complete || !state.isLoggedIn
    if (preventPass === true) {
        show = true
    }

    return {
        isUserLoaded: state.user.complete,
        isUserLoggedIn: state.isLoggedIn,
        userOnWhiteList,
        user: user,
        show: show,
        returnUrl: window.location.href,
        rev: new Date().getTime(),
    }
}

const mapDispatchToPropsRU = (dispatch) => {
    return {
        sendMagicLink: (email, link, cb) => {
            dispatch(act.sendMagicLink(email, link, cb))
        },
        loginUserByCode: (userId, code, cb) => {
            dispatch(act.loginUserByCode(userId, code, cb))
        },
        reset: () => {
            dispatch({ type: "COMMON_RESET" })
        },
    }
}

export const ForceLogin = connect(
    mapStateToPropsRU,
    mapDispatchToPropsRU
)(ForceLoginDialog)

export const checkWhitelisted = (email, whitelist) => {
    let parts = email.split("@")
    //check for whitelisted domain
    if (whitelist[sha1(parts[1])] === "d") {
        return true
    }
    let hash = sha1(email)
    return whitelist[hash] === "e"
}

export const addToWhiteList = (email) => {
    return new Promise((resolve, reject) => {
        let url =
            "https://apkzbbs5q8.execute-api.us-east-1.amazonaws.com/default/tracebot-whitelist-api"
        let data = JSON.stringify({ email: email })
        let opts = {
            method: "POST",
            mode: "no-cors",
            body: data,
            headers: {
                ContentType: "application/json",
                Accept: "*/*",
            },
        }

        fetch(url, opts).then((response) => {
            resolve(true)
        })
    })
}
